module Meevo.Components.Controls.SmartMover {
    import ResourceCategory = Model.ResourceCategory;


    export class ResourceCategoriesCollection extends SmartMoverApiCollection<ResourceCategory> implements IApiCollection<ResourceCategory> {

        protected get smartMoverHiddenValue() {
            return SmartMoverHiddenValue.EmptyArray;
        }

        get url() {
            return 'resourceCategory';
        }
    }

}